import { Controller } from "@hotwired/stimulus"

// Shows the per-position surcharge grid only while the override checkbox is on.
// The checkbox travels with the form, so the server decides profile vs custom;
// toggling also fires the form's input listener and refreshes the live preview.
export default class extends Controller {
  static targets = ["grid", "checkbox"]

  connect() {
    this.sync()
  }

  sync() {
    this.gridTarget.classList.toggle("hidden", !this.checkboxTarget.checked)
  }
}
